import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ListItemIcon } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HomeIcon from "@mui/icons-material/Home";
import WalletIcon from "@mui/icons-material/Wallet";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import StoreIcon from "@mui/icons-material/Store";
import { useRouter, usePathname } from "next/navigation";
import { Loader } from "../genericComponents/MainLoader/Loader";

interface DropDownProps {
  handleLogout: any;
}

const DropDown: React.FC<DropDownProps> = ({ handleLogout }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const open = Boolean(anchorEl);
  const router = useRouter();
  const pathName = usePathname();

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (e: any, route: any) => {
    e.preventDefault();
    if ("/" + route !== pathName) {
      setLoading(true);
    }
    switch (route) {
      case "profile":
        router.push("/profile");
        setAnchorEl(null);
        break;
      case "appointments":
        router.push("/appointments");
        setAnchorEl(null);
        break;
      case "wallet":
        router.push("/wallet");
        setAnchorEl(null);
        break;
      case "addresses":
        router.push("/addresses");
        setAnchorEl(null);
        break;
      case "contact":
        router.push("/contact");
        setAnchorEl(null);
        break;
      case "contact-franchise":
        router.push("/contact-franchise");
        setAnchorEl(null);
        break;
      case "store":
        router.push("/store");
        setAnchorEl(null);
        break;
      default:
        router.push("/");
        break;
    }
  };

  return (
    <div>
      {loading && <Loader />}
      <Button
        id="profile-menu-button"
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        color="success"
        sx={{
          padding: { xs: "8px 10px", sm: "10px 14px" },
          borderRadius: "999px",
          marginLeft: 0,
          background:
            "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
          textTransform: "none",
          fontWeight: 700,
          minWidth: { xs: "auto", sm: "96px" },
          width: { xs: "auto", sm: "96px", md: "100px" },
          height: { xs: "34px", sm: "38px", md: "40px" },
          boxShadow: "0 10px 22px rgba(18,53,36,0.2)",
          flexShrink: 0,
          "&:hover": {
            background:
              "linear-gradient(135deg, #0f2a1c 0%, #1a6b42 100%)",
          },
        }}
      >
        <PersonIcon sx={{ fontSize: { xs: "18px", sm: "20px" } }} />
        &nbsp;Profile
      </Button>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.12))",
            background: "linear-gradient(180deg, #1a6b42 0%, #123524 100%)",
            color: "white",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
              background: "#1f7a4d",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "appointments")}
        >
          <ListItemIcon>
            <CalendarMonthIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Appointments
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "profile")}
        >
          <ListItemIcon>
            <PersonIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "addresses")}
        >
          <ListItemIcon>
            <HomeIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Addresses
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "wallet")}
        >
          <ListItemIcon>
            <WalletIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Wallet
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "contact")}
        >
          <ListItemIcon>
            <ContactMailIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Contact Us
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "contact-franchise")}
        >
          <ListItemIcon>
            <StoreIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Franchise
        </MenuItem>
        <MenuItem
          sx={{ minHeight: "auto" }}
          onClick={(e) => handleNavigate(e, "store")}
        >
          <ListItemIcon>
            <ShoppingBagIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Store
        </MenuItem>
        <MenuItem sx={{ minHeight: "auto" }} onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: "white" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default DropDown;
